<template>
    <v-container
        :fluid="!$vuetify.breakpoint.mobile"
        :style="!$vuetify.breakpoint.mobile ? 'padding: 30px' : ''"
    >
        <v-row v-for="(slot, i) in $slots" dense :key="i">
            <slot :name="i"></slot>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'StackedLayout'
}
</script>
